export default function assetUrl(url) {
  if (!url) return url;
  if (typeof url !== "string") return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;

  const base = import.meta.env.BASE_URL || "/";
  const normalizedBase = base.endsWith("/") ? base : `${base}/`;
  if (normalizedBase !== "/" && url.startsWith(normalizedBase)) {
    return url;
  }
  if (normalizedBase !== "/") {
    const trimmedBase = normalizedBase.replace(/\/$/, "");
    if (url === trimmedBase || url.startsWith(`${trimmedBase}/`)) {
      return url;
    }
  }
  return url.startsWith("/") ? `${normalizedBase}${url.slice(1)}` : `${normalizedBase}${url}`;
}
